import { useEffect, useState, useContext } from "react"
import { CartContext } from "../context/CartContext"

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"
function RecentlyViewed(){

const [products,setProducts] = useState([])
const { addToCart } = useContext(CartContext)

useEffect(()=>{

const recent = JSON.parse(localStorage.getItem("recentProducts")) || []

setProducts(recent)

},[])

if(products.length === 0) return null

return(

<div className="recentSection">

<h2>Recently Viewed</h2>

<Swiper
modules={[Navigation, Autoplay]}
navigation
loop={true}
spaceBetween={20}
slidesPerView={3}
autoplay={{
delay:2500,
disableOnInteraction:false
}}
breakpoints={{
320:{slidesPerView:1},
768:{slidesPerView:2},
1024:{slidesPerView:3}
}}
>

{products.map(p=>(

<SwiperSlide key={p.id}>

<div className="recCard">

<img src={p.images[0]?.src} alt={p.name}/>

<h4>{p.name}</h4>

<p>₹{Number(p.prices?.price) / 100}</p>

<button onClick={()=>addToCart(p)}>
Add to Cart
</button>

</div>

</SwiperSlide>

))}

</Swiper>

</div>

)

}

export default RecentlyViewed